import React from 'react';
import { useNotificationContext } from '../../context/NotificationContext';
import { BadgeContainer, Badge, OfflineIndicator } from './styles';

/**
 * NotificationBadge - Shows unread notification count with real-time updates
 * Uses shared NotificationContext to avoid duplicate WebSocket subscriptions
 */
const NotificationBadge = ({ children, showOfflineIndicator = false }) => {
  const { unreadCount, isConnected } = useNotificationContext();

  return (
    <BadgeContainer>
      {children}
      {unreadCount > 0 && (
        <Badge>{unreadCount > 99 ? '99+' : unreadCount}</Badge>
      )}
      {showOfflineIndicator && !isConnected && (
        <OfflineIndicator title="WebSocket disconnected" />
      )}
    </BadgeContainer>
  );
};

export default NotificationBadge;
